import { render, staticRenderFns } from "./editProduct.pug?vue&type=template&id=d2b003f0&lang=pug&"
import script from "./editProduct.ts?vue&type=script&lang=ts&"
export * from "./editProduct.ts?vue&type=script&lang=ts&"
import style0 from "./editProduct.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports